/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".module-placeholder-host[_ngcontent-%COMP%]{position:relative}.module-placeholder-host[_ngcontent-%COMP%]   .module-placeholder-container[_ngcontent-%COMP%]{position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.kpi-container[_ngcontent-%COMP%]   .kpi-row[_ngcontent-%COMP%]{margin-left:-5px;margin-right:-5px}.kpi-container[_ngcontent-%COMP%]   .kpi-row[_ngcontent-%COMP%]   .kpi-col[_ngcontent-%COMP%]{padding-left:5px;padding-right:5px}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/main/influencer/new-kpi/new-kpi.component.scss.shim.ngstyle.js.pre-build-optimizer.js